import React, { useState, useEffect } from 'react';
import { AgGridReact } from 'ag-grid-react';
import 'ag-grid-community/styles/ag-theme-alpine.css';
import {
  ModuleRegistry,
  AllCommunityModule,
  themeAlpine,
  colorSchemeDarkBlue,
} from "ag-grid-community";


ModuleRegistry.registerModules([AllCommunityModule]);

const themeDarkBlue = themeAlpine.withPart(colorSchemeDarkBlue);

const Table = () => {
  const [rowData, setRowData] = useState([]);
  const [columnDefs] = useState([
    { field: 'date', sortable: true, filter: true, colId: 'date' },
    { field: 'base', sortable: true, filter: true, colId: 'base' },
    { field: 'target', sortable: true, filter: true, colId: 'target' },
    { field: 'rate', sortable: true, filter: true, colId: 'rate' },
    { field: 'reverse_rate', sortable: true, filter: true, colId: 'reverse_rate' },
  ]);

  // Load data
  useEffect(() => {
    fetch('https://frankfurterdashboard.onrender.com/rates-from-db')
      .then((res) => res.json())
      .then((data) => {
        setRowData(data);
      })
      .catch((err) => console.error('Error fetching data:', err));
  }, []);

  const onGridReady = (params) => {
    try {
      const savedState = localStorage.getItem('agGridState');
      if (savedState) {
        const { columnState, filterState } = JSON.parse(savedState);
      
        // Apply column state
        if (columnState && columnState.length > 0) {
          params.api.applyColumnState({
            state: columnState,
            applyOrder: true
          });
        }
      
        // Apply filter state
        if (filterState) {
          params.api.setFilterModel(filterState);
        }
      }
    } catch (error) {
      console.error('Error loading column state:', error);
    }
  };

  const saveGridState = (params) => {
    try {
      const columnState = params.api.getColumnState();
      const filterState = params.api.getFilterModel();

      const state = {
        columnState,
        filterState
      };
      
      localStorage.setItem('agGridState', JSON.stringify(state));


    } catch (error) {
      console.error('Error saving column state:', error);
    }
  };

  return (
    <div style={{ 
      height: 600,
      width: 'auto',
      margin: 'auto',
      display: 'flex', 
      flexDirection: 'column',
      borderRadius: '8px',
      boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1), 0 1px 3px rgba(0, 0, 0, 0.08)',
      border: '1px solid #e2e8f0'
    }}>
      <h2>Exchange Rate Table</h2>
      <AgGridReact
        theme={themeDarkBlue}
        rowData={rowData}
        columnDefs={columnDefs}
        pagination={true}
        paginationPageSize={20}
        animateRows={true}
        onGridReady={onGridReady}
        onColumnMoved={saveGridState}
        onColumnResized={saveGridState}
        onFilterChanged={saveGridState}
        onSortChanged={saveGridState}
      />
    </div>
  );
};

export default Table;